module.exports = __webpack_public_path__ + "static/media/SimonFraser.91a8b49d.png";